module.exports = __webpack_public_path__ + "static/img/partner-mly.bc97159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner-mly.png
// module id = RICL
// module chunks = 0